import { NavLink, Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { LogOut, LayoutDashboard, FileText, User } from "lucide-react";
import { useAuth } from "../../lib/auth";
import PageShell from "../../components/marketing/PageShell";
import BrepLogo from "../../components/BrepLogo";

const LINKS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/dashboard/my-reviews", label: "My Reviews", icon: FileText },
  { to: "/dashboard/profile", label: "Profile", icon: User },
];

export default function DashboardLayout() {
  const { user, ready, logout } = useAuth();
  const loc = useLocation();

  if (!ready) return <PageShell testid="page-dashboard-loading"><div className="p-12 text-white/40">Loading…</div></PageShell>;
  if (!user) return <Navigate to={`/?redirect=${encodeURIComponent(loc.pathname)}`} replace />;

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-[11px] tracking-[0.22em] uppercase transition-colors border-l-2 ${
      isActive ? "border-[#2A5BFF] text-white bg-white/[0.02]" : "border-transparent text-white/60 hover:text-white"
    }`;

  return (
    <PageShell testid="page-dashboard">
      <div className="min-h-screen grid grid-cols-1 lg:grid-cols-[240px_1fr]">
        {/* Sidebar (desktop) + top bar (mobile) */}
        <aside className="lg:min-h-screen border-b lg:border-b-0 lg:border-r border-white/10 bg-[#050510] sticky top-0 z-40" data-testid="dashboard-sidebar">
          <div className="p-6 border-b border-white/10 flex items-center justify-between">
            <Link to="/" data-testid="dashboard-logo"><BrepLogo size="sm" /></Link>
          </div>
          <nav className="flex lg:flex-col overflow-x-auto lg:overflow-visible py-2">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} className={linkCls} data-testid={`dashboard-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <l.icon size={14} /> <span className="hidden sm:inline lg:inline">{l.label}</span>
              </NavLink>
            ))}
            <button onClick={logout} className="flex items-center gap-3 px-4 py-3 text-[11px] tracking-[0.22em] uppercase text-white/60 hover:text-white transition-colors border-l-2 border-transparent" data-testid="dashboard-nav-logout">
              <LogOut size={14} /> <span className="hidden sm:inline lg:inline">Logout</span>
            </button>
          </nav>
          <div className="hidden lg:block px-4 pb-6 mt-auto">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40">Signed in as</div>
            <div className="text-white/80 text-sm mt-1 truncate">{user.email}</div>
          </div>
        </aside>

        <main className="min-h-screen">
          <Outlet />
        </main>
      </div>
    </PageShell>
  );
}
